import { Routes } from '@angular/router';
import { GamesPage } from './games-page';
import { LingoPage } from './lingo-page/lingo-page';
import { MemoryMatchPage } from './memory-match-page/memory-match-page';

export const mechanicGameRoutes: Routes = [
  {
    path: '',
    component: GamesPage,
  },
  {
    path: 'memory-match',
    component: MemoryMatchPage,
  },
  {
    path: 'klanko',
    component: LingoPage,
  },
];
